class EarningsExpensesOverheadUrlPath {
    public static BASE = "/earningsExpenses/overhead";

    public static GROUPED = EarningsExpensesOverheadUrlPath.BASE + "/grouped";
}

export default EarningsExpensesOverheadUrlPath;